var map = {
	"./ju.png": "97Ti",
	"./wan.png": "Wl8+",
	"./zhong.png": "boTc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "to0Q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/state ^\.\/.*\.png$
// module id = to0Q
// module chunks = 1